"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var theme_1 = require("../../utils/theme");
var PullPanel_1 = tslib_1.__importDefault(require("../PullPanel"));
var DatePicker_1 = tslib_1.__importDefault(require("./rmc/DatePicker"));
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var helper_1 = require("../../utils/helper");
var noLocale = {
    year: '',
    month: '',
    day: '',
    hour: ' ',
    minute: '',
    am: '',
    pm: ''
};
var DateTimePicker = (function (_super) {
    tslib_1.__extends(DateTimePicker, _super);
    function DateTimePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentValue: _this.getDefaultValue(),
            disableScrollTransition: true,
        };
        _this.mobileDatePickerContainerRef = React.createRef();
        _this.handleChange = function (date) {
            var value = dayjs_1.default(date);
            _this.setState({ currentValue: value });
            _this.props.onChange(value);
        };
        _this.handleOk = function () {
            _this.props.onOk(_this.getCurrentValue());
        };
        _this.enableScrollTransition = function () {
            _this.setState({ disableScrollTransition: false });
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, visible = _b.visible, zIndex = _b.zIndex, mode = _b.mode, minDate = _b.minDate, maxDate = _b.maxDate, itemStyle = _b.itemStyle, maxHour = _b.maxHour, maxMinute = _b.maxMinute, minHour = _b.minHour, minMinute = _b.minMinute, minuteStep = _b.minuteStep, onCancel = _b.onCancel;
            var disableScrollTransition = _this.state.disableScrollTransition;
            var classes = classNames(prefixCls, className, prefixCls + "-" + mode, (_a = {},
                _a[prefixCls + "-no-animation"] = disableScrollTransition,
                _a));
            var value = _this.getCurrentValue();
            return (h(PullPanel_1.default, { visible: visible, onOk: _this.handleOk, onCancel: onCancel, okText: "\u5B8C\u6210", cancelText: "\u53D6\u6D88", title: "", zIndex: zIndex, headerSize: "small", className: classNames(prefixCls + "-panel"), style: { backgroundColor: '#f7f8f9' }, showHeaderBorder: false, destroyOnClose: true },
                h("div", { className: classes, ref: _this.mobileDatePickerContainerRef, style: style, onTouchStart: _this.enableScrollTransition },
                    h("div", { className: classNames(prefixCls + "-indicator") }),
                    h(DatePicker_1.default, { prefixCls: "dui-m-date-picker", pickerPrefixCls: "dui-m-picker", locale: noLocale, date: value.toDate(), onDateChange: _this.handleChange, mode: mode, minDate: minDate.toDate(), maxDate: maxDate.toDate(), itemStyle: itemStyle, maxHour: maxHour, maxMinute: maxMinute, minHour: minHour, minMinute: minMinute, minuteStep: minuteStep }))));
        };
        return _this;
    }
    DateTimePicker.prototype.getCurrentValue = function () {
        return this.props.value || this.state.currentValue;
    };
    DateTimePicker.prototype.getDefaultValue = function () {
        return this.props.defaultValue || dayjs_1.default();
    };
    DateTimePicker.prototype.preventTouchMove = function () {
        var dom = this.mobileDatePickerContainerRef.current;
        if (!dom || dom.__dui_touch_move_stopped__) {
            return;
        }
        dom.addEventListener('touchmove', function (e) {
            e.stopPropagation();
            e.cancelable && e.preventDefault();
        }, { passive: false });
        dom.__dui_touch_move_stopped__ = true;
    };
    DateTimePicker.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.setState({ currentValue: this.getDefaultValue(), disableScrollTransition: true });
            this.preventTouchMove();
        }
    };
    DateTimePicker.prototype.componentDidMount = function () {
        this.preventTouchMove();
    };
    DateTimePicker.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return DateTimePicker;
}(React.Component));
exports.default = DateTimePicker;
DateTimePicker.defaultProps = {
    prefixCls: 'dui-m-datetimepicker',
    mode: 'date',
    minDate: dayjs_1.default('1900-01-01T00:00:00'),
    maxDate: dayjs_1.default('2100-12-31T23:59:59'),
    onChange: helper_1.emptyFn,
    onOk: helper_1.emptyFn,
    onCancel: helper_1.emptyFn,
    minHour: 0,
    maxHour: 23,
    minMinute: 0,
    maxMinute: 59,
    minuteStep: 1,
};
DateTimePicker.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    itemStyle: PropTypes.object,
    visible: PropTypes.bool,
    defaultValue: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func,
    mode: PropTypes.oneOf(['date', 'time', 'datetime', 'year', 'month']),
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    minHour: PropTypes.number,
    maxHour: PropTypes.number,
    minMinute: PropTypes.number,
    maxMinute: PropTypes.number,
    minuteStep: PropTypes.number,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    zIndex: PropTypes.number,
};
